/* Keep Judge.me display names private, including asynchronously loaded carousel cards. */
(() => {
  const selector = '.jdgm-reviewer-name, .jm-reviewer-info__name, .jdgm-rev__author';
  function abbreviate(value) {
    const text = (value || '').trim();
    if (!text || /^(?:\p{L}\.)+$/u.test(text)) return text;
    return text.split(/[\s.\-]+/u).filter(Boolean).map(part => Array.from(part)[0].toLocaleUpperCase() + '.').join('');
  }
  function protect(root) {
    const names = [...(root.querySelectorAll?.(selector) || [])];
    const ancestor = root.closest?.(selector);
    if (ancestor && !names.includes(ancestor)) names.unshift(ancestor);
    names.forEach(el => {
      const initials = abbreviate(el.textContent);
      if (el.textContent !== initials) el.textContent = initials;
      ['title', 'aria-label'].forEach(attr => {
        if (el.hasAttribute(attr) && el.getAttribute(attr) !== initials) el.setAttribute(attr, initials);
      });
      el.setAttribute('data-nfc-private-name', '');
    });
  }
  protect(document);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'childList') {
        record.addedNodes.forEach(node => protect(node.nodeType === 1 ? node : node.parentElement || document));
      } else protect(record.target.nodeType === 1 ? record.target : record.target.parentElement || document);
    });
  }).observe(document.body, { subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['title','aria-label'] });
})();
